import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { fetchPage, unloadPage } from './actions';
import { PageTypes } from './config/pageTypes';

export function useLegacyApi(dependencies: unknown[] | undefined, pageType: PageTypes): void {
  const dispatch = useDispatch();
  const location = useLocation();
  const { lang, ...params } = useParams();

  const deps = dependencies ? [lang, ...dependencies] : [lang];

  function handleUnloadPage(): void {
    dispatch(unloadPage(pageType));
  }

  useEffect(() => {
    dispatch(fetchPage(lang || '', pageType, params, location));
    return handleUnloadPage;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
